import {
  LoadContentFromSessionCache,
  SetAllTemplates,
  SetAvailableLayouts,
  SetCurrentLayout,
  SetCurrentTemplate,
  SetSelectedReference,
  DeleteAuthoredDocumentById,
  AddDownloadInProgress,
  RemoveDownloadInProgress,
} from '~/constants/mutations';
import {
  GetAllTemplates,
  GetAuthoredDocuments,
  GetAvailableLayouts,
  GetCurrentDesignSystemDocumentElements,
  GetCurrentLayout,
  GetCurrentTemplate,
  GetDsConfig,
  GetEditorContent,
  GetEmailTokens,
  GetRedoStack,
  GetSelectedAuthoredDocument,
  GetSelectedObjectDocumentEditor,
  GetSelectedReference,
  GetTotalMediaImages,
  GetUndoStack,
  IsDownloadInProgress,
} from '~/constants/getters';
import {
  SetAuthoredDocuments,
  SetCurrentDesignSystemDocumentElements,
  SetCurrentDsConfig,
  SetEmailTokens,
  SetSelectedAuthoredDocument,
  SetSelectedObjectDocumentEditor,
  SetSelectedReferencePanel,
  SetTotalMediaImages,
} from '~/constants/actions';

const defaultState = () => {
  return {
    selectedReference: {},
    templates: [],
    currentTemplate: null,
    currentDesignSystemDocumentElements: null,
    currentDsConfig: {},
    emailTokens: [],
    selectedObjectDocumentEditor: {
      selectedLayout: {},
      selectedElement: {},
    },
    availableLayouts: [],
    currentLayout: null,
    authoredDocuments: [],
    selectedAuthoredDocument: null,
    totalMediaImages: 0,
    downloadInProgressDocuments: [],
  };
};

export const state = defaultState();

export const mutations = {
  [SetAllTemplates]: (state, data) => {
    state.templates = data;
  },
  [SetCurrentTemplate]: (state, data) => {
    state.currentTemplate = data;
  },
  [SetCurrentDesignSystemDocumentElements]: (state, data) => {
    state.currentDesignSystemDocumentElements = data;
  },
  [SetSelectedObjectDocumentEditor]: (state, data) => {
    state.selectedObjectDocumentEditor = {
      ...state.selectedObjectDocumentEditor,
      ...data,
    };
  },

  [SetAvailableLayouts]: (state, data) => {
    state.availableLayouts = data;
  },
  [SetCurrentLayout]: (state, data) => {
    state.currentLayout = data;
  },
  [SetAuthoredDocuments]: (state, data) => {
    state.authoredDocuments = data;
  },
  [SetSelectedAuthoredDocument]: (state, data) => {
    state.selectedAuthoredDocument = data;
  },
  [SetSelectedReference](state, ref) {
    state.selectedReference = ref;
  },
  [SetTotalMediaImages](state, data) {
    state.totalMediaImages = data;
  },
  [SetCurrentDsConfig](state, data) {
    state.currentDsConfig = data;
  },
  [SetEmailTokens](state, data) {
    state.emailTokens = data;
  },
  [DeleteAuthoredDocumentById](state, documentId) {
    state.authoredDocuments = state.authoredDocuments.filter((doc) => doc.id !== documentId);
  },
  [AddDownloadInProgress](state, documentId) {
    state.downloadInProgressDocuments = [...state.downloadInProgressDocuments, documentId];
  },
  [RemoveDownloadInProgress](state, documentId) {
    state.downloadInProgressDocuments = state.downloadInProgressDocuments.filter((id) => id !== documentId);
  },
};

export const actions = {
  [SetAllTemplates]({ commit }, data) {
    commit(SetAllTemplates, data);
  },
  [SetCurrentTemplate]({ commit }, data) {
    commit(SetCurrentTemplate, data);
  },
  [SetSelectedObjectDocumentEditor]: ({ commit }, data) => {
    commit(SetSelectedObjectDocumentEditor, data);
  },
  [SetCurrentDesignSystemDocumentElements]: ({ commit }, data) => {
    commit(SetCurrentDesignSystemDocumentElements, data);
  },
  [LoadContentFromSessionCache]: ({ commit }) => {
    commit(LoadContentFromSessionCache);
  },
  [SetAvailableLayouts]: ({ commit }, data) => {
    commit(SetAvailableLayouts, data);
  },
  [SetCurrentLayout]: ({ commit }, data) => {
    commit(SetCurrentLayout, data);
  },
  [SetAuthoredDocuments]: ({ commit }, data) => {
    commit(SetAuthoredDocuments, data);
  },
  [SetSelectedAuthoredDocument]: ({ commit }, data) => {
    commit(SetSelectedAuthoredDocument, data);
  },
  [SetSelectedReferencePanel]: ({ commit }, reference) => {
    commit(SetSelectedReference, reference);
  },
  [SetTotalMediaImages]: ({ commit }, data) => {
    commit(SetTotalMediaImages, data);
  },
  [SetCurrentDsConfig]({ commit }, data) {
    commit(SetCurrentDsConfig, data);
  },
  [SetEmailTokens]({ commit }, data) {
    commit(SetEmailTokens, data);
  },
  [DeleteAuthoredDocumentById]({ commit }, documentId) {
    commit(DeleteAuthoredDocumentById, documentId);
  },
  [AddDownloadInProgress]({ commit }, documentId) {
    commit(AddDownloadInProgress, documentId);
  },
  [RemoveDownloadInProgress]({ commit }, documentId) {
    commit(RemoveDownloadInProgress, documentId);
  },
};

export const getters = {
  [GetAllTemplates]: (state) => state.templates,
  [GetCurrentTemplate]: (state) => state.currentTemplate,
  [GetCurrentDesignSystemDocumentElements]: (state) => state.currentDesignSystemDocumentElements,
  [GetSelectedObjectDocumentEditor]: (state) => state.selectedObjectDocumentEditor,
  [GetEditorContent]: (state) => state.editorContent,
  [GetAvailableLayouts]: (state) => state.availableLayouts,
  [GetCurrentLayout]: (state) => state.currentLayout,
  [GetAuthoredDocuments]: (state) => state.authoredDocuments,
  [GetSelectedAuthoredDocument]: (state) => state.selectedAuthoredDocument,
  [GetSelectedReference](state) {
    return state.selectedReference;
  },
  [GetUndoStack]: (state) => state.undoStack,
  [GetRedoStack]: (state) => state.redoStack,
  [GetTotalMediaImages]: (state) => state.totalMediaImages,
  [GetDsConfig]: (state) => state.currentDsConfig,
  [GetEmailTokens]: (state) => state.emailTokens,
  [IsDownloadInProgress]: (state) => (documentId) => state.downloadInProgressDocuments.includes(documentId),
};

export default {
  namespaced: true, // Important for namespacing module
  state,
  mutations,
  actions,
  getters,
};
